export const ORDER_STATUS = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
  CANCELED: 'CANCELED',
  DELETED: 'DELETED'
} as const;

export type OrderStatus = keyof typeof ORDER_STATUS;

export const ORDER_TYPE = {
  TOWERS: 'TOWERS',
  SPANS: 'SPANS',
  BOTH: 'BOTH'
} as const;

export type OrderType = keyof typeof ORDER_TYPE;


